var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelpdeskIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7.5a6.5 6.5 0 01-9.842 5.576L1 14l1.741-3.483A6.5 6.5 0 1115 7.5zm-3.25-2.167l1.083 1.084L11.75 7.5h-6.5L4.167 6.417 5.25 5.333h6.5zM8.5 8.583H5.25L4.167 9.667 5.25 10.75H8.5l1.083-1.083L8.5 8.583zm8.5-.582a8 8 0 01-10.155 7.706A6.498 6.498 0 0012.5 19a6.47 6.47 0 003.18-.83L19 19l-1.087-2.9A6.47 6.47 0 0019 12.5c0-1.844-.768-3.51-2.002-4.692L17 8z",
    fill: "#9A9CAC"
  })));
}

export default SvgHelpdeskIcon;